import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

const state = {
  user: {},
  drafts: {
    order: {}
  },
  openid: null,
  openid_at: null,//最后openid更新时间
  bizType: null
}

const mutations = {
  login(state, user) {
    state.user = user;
  },
  openid(state, openid) {
    if (!_.isEmpty(openid)) {
      state.openid = openid;
      state.openid_at = Date.now();
    }
  },
  logout(state) {
    state.user = {};
    state.drafts = {};
    // state.openid = null;
    // state.openid_at = null;
    state.bizType = null;
    
    // 注销的话，应该不需要清空微信状态，因为再获取也是一样
    // localStorage.clear();
  },
  bizType(state, bizType) {
    state.bizType = bizType;
  },
  stashOrder(state, order, extend = false) {
    state.drafts.new_order = extend? _.extend({}, order, state.drafts.order) : order;
  },
  /**
   * 最新的order结构
   * @param {*} state 
   * @param {*} profile 
   * @param {*} extend 
   */
  saveOrder(state, order, extend) {
    state.drafts.new_order = extend ? _.extend({}, order, state.drafts.new_order) : order;
  },
  initialiseStore(state) {
    // Check if the ID exists
    if(localStorage.getItem('store')) {
      // Replace the state object with the stored item
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem('store')))
      );
    }
  }
}

const store = new Vuex.Store({
  state,
  mutations,
})

store.subscribe((mutation, state) => {
  // console.log("存储", mutation, state);
  localStorage.setItem('store', JSON.stringify(state));
})


export default store;


// WEBPACK FOOTER //
// ./src/router/store.js